export default "__VITE_ASSET__BJiBtm0X__"